import _typeof from "@babel/runtime/helpers/typeof";
import { MessageType } from "../../api/types/history";
export var excludeMessageWithEqualId = function excludeMessageWithEqualId(list) {
  return list.filter(function (message, i) {
    return list.findIndex(function (_ref) {
      var messageId = _ref.messageId;
      return messageId === message.messageId;
    }) === i;
  });
};
export var getLastSession = function getLastSession(history) {
  return history.list.slice(-1)[0];
};
export var getMessageText = function getMessageText(message) {
  var content = message.message.content;
  return _typeof(content) === 'object' ? content.text : content;
};
export var isFileMessage = function isFileMessage(type) {
  return type === MessageType.Img || type === MessageType.FileDoc;
};
export var getMessageFile = function getMessageFile(message) {
  var content = message.message.content;
  return _typeof(content) === 'object' ? {
    fileUrl: content === null || content === void 0 ? void 0 : content.fileUrl,
    filePreviewUrl: content === null || content === void 0 ? void 0 : content.filePreviewUrl,
    size: content === null || content === void 0 ? void 0 : content.size,
    name: content === null || content === void 0 ? void 0 : content.name
  } : {
    fileUrl: '',
    filePreviewUrl: '',
    size: undefined,
    name: ''
  };
};
export var getMessageNodeById = function getMessageNodeById(id) {
  return document.querySelector("[data-message-id=\"".concat(id, "\"]"));
};